/** @format */

import React from "react";
import commonStyle from "../common.module.scss";
import CustomButton from "../../../custom/custom-button/CustomButton";
import { t } from "i18next";

const OrdersSectionItemCreate = ({
  onSubmit,
  onSubmitDraft,
  isLoading,
  isHidden,
  isDisabled = false,
  submitText,
  isRailway = false,
}) => {
  const clickHandle = () => {
    if (!isDisabled && onSubmit) onSubmit();
  };

  return (
    <>
      <div className={commonStyle.createContainer}>
        {!isRailway && (
          <CustomButton
            text={t("ordersCreateDesktop.paymentSection.saveToDraft")}
            isMain
            onClick={onSubmitDraft}
            isUnderline
            isBlackText
            isHidden={isHidden}
          />
        )}
        <CustomButton
          text={submitText ?? t("ordersCreateDesktop.paymentSection.publishOrder")}
          isMain
          onClick={clickHandle}
          isLoading={isLoading}
          isDisabled={isDisabled}
          disabled={isDisabled}
        />
      </div>
    </>
  );
};

export default OrdersSectionItemCreate;
